document.addEventListener("DOMContentLoaded", () => {
  const availabilityWrapper = document.getElementById("availability-wrapper");
  const availabilityBtn = document.getElementById("add-availability-btn");
  const MAX_STATIONS = 3;
  
  if (availabilityWrapper && availabilityBtn) {
    const stations = JSON.parse(availabilityWrapper.dataset.stations);
    
    const options = [
      '<option value="">Все станции метро</option>',
      ...stations.map(([id, name]) => `<option value="${id}">${name}</option>`)
    ].join("");
    
    const timeOptions = Array.from({ length: 24 }, (_, h) =>
      [0, 30].map(m => {
        const hour = String(h).padStart(2, "0");
        const minute = String(m).padStart(2, "0");
        const time = `${hour}:${minute}`;
        
        return `<option value="${time}">${time}</option>`;
      })
    ).flat().join("");
    
    updateAddButtonVisibility()
    
    availabilityBtn.addEventListener("click", () => {
      const activeSlots = availabilityWrapper.querySelectorAll(
        ".availability-slot:not([style*='display: none'])"
      );
      
      if (activeSlots.length >= MAX_STATIONS) {
        return;
      }
      
      const newId = Date.now();
      const addLocationBlock = availabilityWrapper.querySelector(".add-location");

      addLocationBlock.insertAdjacentHTML("beforebegin", `
      <div class="availability-slot" style="margin-bottom:15px">

        <select
          name="user_profile[availability_slots_attributes][${newId}][metro_station_id]"
          data-plugin="select2"
          class="">
          ${options}
        </select>
        
        <div class="time-select">
          <div class="from">
            Время с:
            <select
              class="select"
              name="user_profile[availability_slots_attributes][${newId}][from_time]">
              ${timeOptions}
            </select>
          </div>
    
          <div class="to_time">
            по:
            <select
              class="select"
              name="user_profile[availability_slots_attributes][${newId}][to_time]">
              ${timeOptions}
            </select>
          </div>
        
          <div class="btn-remove">
            <button
              type="button"
              class="btn primary"
              onclick="removeAvailabilitySlot(this)">
              Удалить
            </button>
          </div>
         </div>
      </div>
    `);
      updateAddButtonVisibility()
      
      $('[data-plugin="select2"]').select2({
        placeholder: "Все станции метро",
        width: "100%",
      });
    });
  }
})

window.removeAvailabilitySlot = function(button) {
  const field = button.closest(".availability-slot");
  const destroyInput = field.querySelector('input[name*="_destroy"]');
  
  if (destroyInput) {
    destroyInput.value = "1";
    field.style.display = "none";
  } else {
    field.remove();
  }
  
  updateAddButtonVisibility()
}

function updateAddButtonVisibility() {
  let MAX_STATIONS = 3
  const availabilityBtn = document.getElementById("add-availability-btn");
  const availabilityWrapper = document.getElementById("availability-wrapper");
  const activeSlots = availabilityWrapper.querySelectorAll(".availability-slot:not([style*='display: none'])");
  
  availabilityBtn.style.display = activeSlots.length >= MAX_STATIONS ? "none" : "";
}
